import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const MAX_LABEL_LEN = 12;
const CustomTick = ({ x, y, payload }) => {
  const text = payload.value?.length > MAX_LABEL_LEN
    ? `${payload.value.substring(0, MAX_LABEL_LEN)}…`
    : payload.value;
  return (
    <text x={x} y={y + 10} textAnchor="middle" fill="#6c757d" fontSize={11}>
      {text}
    </text>
  );
};

const LineChats = ({ jsonData, selectedChart, onChartChange }) => {
  const keys = jsonData ? Object.keys(jsonData) : [];

  const effectiveChart = (selectedChart && jsonData && jsonData[selectedChart])
    ? selectedChart
    : keys[0] || '';

  if (!jsonData || keys.length === 0) return null;

  const selectedData = jsonData[effectiveChart];
  if (!selectedData || !selectedData.chats || !selectedData.chats[0]) return null;

  const chartData = selectedData.chats[0].XAxis.map((label, i) => ({
    name: label,
    value: selectedData.chats[0].YAxis[i] ?? 0,
  }));

  return (
    <div style={{ borderRadius: "10px", marginTop: "8px" }}>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData} margin={{ top: 5, right: 20, left: 0, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            interval={0}
            tick={<CustomTick />}
          />
          <YAxis />
          <Tooltip />
          <Legend verticalAlign="top" />
          <Line
            type="monotone"
            dataKey="value"
            name={selectedData.name}
            stroke="#008FFB"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChats;
